import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["form", "onEdit", "onClose"];
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Icon } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FormDetails');
function FormDetails(_ref) {
  let {
      form,
      onEdit,
      onClose
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const details = useMemo(() => {
    if (!(form !== null && form !== void 0 && form.detail)) return null;
    const sections = [];
    let rows = [];
    form.detail.forEach((el, i) => {
      if (el.type === 'title') {
        if (sections.length !== 0) {
          rows = [];
        }
        sections.push(/*#__PURE__*/React.createElement("div", {
          key: i,
          className: classes.box
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.boxHeader
        }, /*#__PURE__*/React.createElement(Text, {
          type: "subtitle1",
          className: classes.boxTitle
        }, el.titleName)), /*#__PURE__*/React.createElement("div", {
          className: classes.boxContent
        }, rows)));
      } else if (el.type === 'text') {
        if (sections.length === 0) {
          sections.push(/*#__PURE__*/React.createElement("div", {
            key: i,
            className: classes.box
          }, /*#__PURE__*/React.createElement("div", {
            className: classes.boxHeader
          }), /*#__PURE__*/React.createElement("div", {
            className: classes.boxContent
          }, rows)));
        }
        rows.push(/*#__PURE__*/React.createElement("div", {
          key: i,
          className: classes.row
        }, /*#__PURE__*/React.createElement(Text, {
          className: classes.rowTitle
        }, el.key), /*#__PURE__*/React.createElement(Text, {
          className: classes.rowText
        }, el.value)));
        if (i === form.detail.length) {
          sections.push(rows);
        }
      }
    });
    return sections;
  }, [classes.box, classes.boxContent, classes.boxHeader, classes.boxTitle, classes.row, classes.rowText, classes.rowTitle, form]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: onClose,
    className: classes.close
  }), /*#__PURE__*/React.createElement(Text, {
    type: "h6"
  }, t('title_form_detail')), /*#__PURE__*/React.createElement("span", null, onEdit && /*#__PURE__*/React.createElement(Icon, {
    name: form.readOnly ? 'visibilityOn' : 'edit',
    onClick: onEdit,
    className: classes.edit
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, details));
}
process.env.NODE_ENV !== "production" ? FormDetails.propTypes = {
  form: PropTypes.object.isRequired
} : void 0;
export default /*#__PURE__*/memo(FormDetails);